import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {

  }

  checkInactivityTimeout(): Observable<any> {
    return this.http.get(this.url + 'api/inactivity');
  }

  blockAccount(clientNumber: number, token: string,isValidation:boolean,code:string): Observable<any> {
    return this.http.get(this.url + 'api/block/account?token='+token+'&client='+clientNumber+'&is2FA='+isValidation+'&code='+code)
  }

  activateAccount(clientNumber: number, token: string,isValidation:boolean,code:string,email:string,type:number): Observable<any> {
    return this.http.get(this.url + 'api/activate/account?token='+token+'&client='+clientNumber+'&is2FA='+isValidation+'&code='+code+'&email='+email+'&type='+type)
  }



  getLinkedDevices(clientNumber: number): Observable<any> {
    return this.http.get(this.url + `api/device/linked?clientNumber=${clientNumber}`);
  }

  unlinkDevicePortal(device:any): Observable<any> {
    return this.http.post(this.url + `api/unlink/device?deviceId=${device.device_id}`,null);
  }

   unlinkDeviceEmail(clientNumber: number, token: string,isValidation:boolean,code:string,email:string,type:number): Observable<any> {
    return this.http.get(this.url + 'api/unlink/device?token='+token+'&client='+clientNumber+'&is2FA='+isValidation+'&code='+code+'&email='+email+'&type='+type)
  }

  checkStatuInvoiceModule(): Observable<any> {
    return this.http.get(this.url + 'api/invoice/module/active');
  }




}
